import firebase from 'firebase'

/* MPDB */
export const fb = firebase.initializeApp({
  apiKey: 'AIzaSyALPWwmq10BocVBxdber0oJJkKjqXEznFg',
  authDomain: 'mpdb-f158c.firebaseapp.com',
  databaseURL: 'https://mpdb-f158c.firebaseio.com',
  projectId: 'mpdb-f158c',
  storageBucket: 'mpdb-f158c.appspot.com',
  messagingSenderId: '238349130540'
})

/* MPDB-2022 */
/*
export const fb = firebase.initializeApp({
  apiKey: 'AIzaSyAg2eFWauTp8l5OJUVAjwcPIWN874f9Mo4',
  authDomain: 'mpdb-2022-87fa8.firebaseapp.com',
  databaseURL: 'https://mpdb-2022-87fa8-default-rtdb.firebaseio.com',
  projectId: 'mpdb-2022-87fa8',
  storageBucket: 'mpdb-2022-87fa8.appspot.com',
  messagingSenderId: '1006408047601',
  appId: '1:1006408047601:web:91de3aaa1f403f80048250'
})
*/



// WEBPACK FOOTER //
// ./src/firebase.js